import { z } from 'zod'

export const baseMapDeploymentSchema = z.object({
	id: z.string(), // unique id
	region: z.string(), // region of the country
	market: z.string(), // country name
	countryCode: z.string().length(2), // country code two letters 'US', 'GB' etc.
})

export type BaseMapDeployment = {
	id: string
	region: string
	market: string
	countryCode: string
}

export const serverReceivedMapDeploymentsSchema = <T extends z.ZodTypeAny>(
	itemSchema: T
) =>
	z.object({
		deployments: z.array(itemSchema),
		creationTimestamp: z.string(),
		version: z.string(),
	})

export type ServerReceivedMapDeployments<T extends BaseMapDeployment> = {
	deployments: T[]
	creationTimestamp: string
	version: string
}
